module.exports = __webpack_public_path__ + "static/img/noData2.8799ae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noData2.png
// module id = QS8P
// module chunks = 4